<section class="pix-data">
  <p class="h5">Pagamento via PIX</p>
  @if (showInternationalHint) {
    <p class="small mb-3" [class.text-muted]="canGenerateQr" [class.alert]="!canGenerateQr" [class.alert-warning]="!canGenerateQr">
      O QR Code PIX só é gerado se o passaporte estiver cadastrado. Sem passaporte, a geração fica bloqueada — use cartão
      de crédito.
    </p>
  }
  <div class="container-pix">
    @if (pixData) {
      <!-- Informações do PIX -->
      @if (pixData.amount > 0) {
        <div class="pix-info mb-3">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted">Valor:</span>
            <strong class="h4">{{ pixData.amount | currency: "BRL" }}</strong>
          </div>
          @if (pixData.expiresAt) {
            <div class="d-flex justify-content-between align-items-center mt-2">
              <span class="text-muted">Validade:</span>
              <span class="badge bg-warning">{{ getPixExpirationTime() }}</span>
            </div>
          }
        </div>
      }

      <!-- QR Code -->
      <div class="d-flex justify-content-center align-items-center mb-3">
        <qr-code [value]="pixData.copyPasteCode" size="300" errorCorrectionLevel="M" />
      </div>

      <!-- Status em tempo real -->
      <div class="status-payment mb-3">
        @if (loading) {
          <p>Carregando...</p>
        } @else {
          <div
            class="alert"
            [ngClass]="{
              'alert-info': statusPaymentPix === 'AGUARDANDO PAGAMENTO',
              'alert-success': statusPaymentPix === 'PAGO',
              'alert-danger': statusPaymentPix === 'FALHOU',
            }">
            <div class="d-flex align-items-center">
              <i
                class="fas me-2"
                [ngClass]="{
                  'fa-clock': statusPaymentPix === 'AGUARDANDO PAGAMENTO',
                  'fa-check-circle': statusPaymentPix === 'PAGO',
                  'fa-times-circle': statusPaymentPix === 'FALHOU',
                }"></i>
              <span>{{ statusPaymentPix }}</span>
            </div>

            <!-- Indicador de conexão WebSocket -->
            <small class="d-block mt-2">
              <i
                class="fas fa-wifi me-1"
                [class.text-success]="isWebSocketConnected"
                [class.text-muted]="!isWebSocketConnected"></i>
              {{
                isWebSocketConnected ? "Conectado - Aguardando confirmação em tempo real" : "Verificando periodicamente"
              }}
            </small>
          </div>
        }
      </div>
      <div class="mb-3">
        <label class="form-label" for="copiaECola">PIX Copia e Cola</label>
        <input type="text" class="form-control" name="copiaECola" [value]="pixData.copyPasteCode" readonly />
      </div>
    }

    <!-- Botões de ação -->
    <div style="display: flex; flex-direction: column; gap: 16px">
      @if (pixData) {
        <app-button (btnClick)="copyPixKey()">
          <i class="fas fa-copy me-2"></i>
          Copiar Código PIX
        </app-button>
        <app-button styleType="secondary" (btnClick)="goToMyOrders()">
          <i class="fas fa-ticket-alt me-2"></i>
          Ver Meus Ingressos
        </app-button>
      } @else {
        <app-button [disabled]="!canGenerateQr || loading" (btnClick)="handleGenerateQrCodeClick()">
          Gerar QR Code
        </app-button>
      }
    </div>
  </div>
</section>
